// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.latencyDisplay_latencyContainer__tOFYF {
    height: 52px;
    border-radius: 7px;
    border-width: 1px;
    border-color: var(--elv-gray-3);
    border-width: 1px;
    border-style: solid;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 18px;
    padding-right: 18px;
    width: 100%;
}

.latencyDisplay_statContainer__Ld16P {
    display: flex;
    align-items: center;
}

.latencyDisplay_statTitle__0yM0V {
    font-size: 10px;
    font-weight: 400;
    color: var(--mantine-color-gray-8);
    margin-right: 5px;
    margin-left: 0px;
}

.latencyDisplay_statValue__HieRF {
    font-size: 21px;
    font-weight: 600;
    color: var(--mantine-color-black);
}

.latencyDisplay_statUnit__UHF\\+e {
    font-size: 10px;
    font-weight: 400;
    color: var(--elv-gray-2);
    margin-left: 2px;
    margin-right: 0px;
}

.latencyDisplay_latencyPlotContainer__\\+Kkjo {
    display: flex;
    align-items: end;
    
    --p50: 0;
    --p99: 0;
    /* TODO: Determine total width of this thing with css variables */
    --total-dur: 2000;
    --total-width: 350px;

    --p50-width: clamp(25px, calc(var(--p50) * var(--total-width) / var(--total-dur)), var(--total-width));
    --p90-width: clamp(25px, calc((var(--p99) * var(--total-width) / var(--total-dur)) - var(--p50-width)), var(--total-width));
}

.latencyDisplay_latencyPlotBox__eLYKR {
    margin-left: 0px;
    margin-right: 0px;
    border-radius: 0px;
    border-top-right-radius: 2px;
    text-indent: 2px;
    text-wrap: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.latencyDisplay_p50PlotBox__svRGg {
    background-color: #b17bdc;
    height: 25px;
    font-size: 10px;
    font-weight: 600;
    color: white;
    width: var(--p50-width);
}

.latencyDisplay_p99PlotBox__D396n {
    background-color: #7544e5;
    height: 22px;
    font-size: 10px;
    font-weight: 600;
    color: white;
    width: var(--p90-width);
}

.latencyDisplay_finalPlotBox__BxgBu {
    background-color: #d9d9d9;
    height: 20px;
    font-size: 12px;
    justify-content: end;
    padding-inline-end: 5px;
    width: calc(var(--total-width) - var(--p50-width) - var(--p90-width));
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/latencyDisplay.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;;IAEhB,QAAQ;IACR,QAAQ;IACR,iEAAiE;IACjE,iBAAiB;IACjB,oBAAoB;;IAEpB,sGAAsG;IACtG,2HAA2H;AAC/H;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IAEI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IAEI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IAEI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,uBAAuB;IACvB,qEAAqE;AACzE","sourcesContent":[".latencyContainer {\n    height: 52px;\n    border-radius: 7px;\n    border-width: 1px;\n    border-color: var(--elv-gray-3);\n    border-width: 1px;\n    border-style: solid;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-left: 18px;\n    padding-right: 18px;\n    width: 100%;\n}\n\n.statContainer {\n    display: flex;\n    align-items: center;\n}\n\n.statTitle {\n    font-size: 10px;\n    font-weight: 400;\n    color: var(--mantine-color-gray-8);\n    margin-right: 5px;\n    margin-left: 0px;\n}\n\n.statValue {\n    font-size: 21px;\n    font-weight: 600;\n    color: var(--mantine-color-black);\n}\n\n.statUnit {\n    font-size: 10px;\n    font-weight: 400;\n    color: var(--elv-gray-2);\n    margin-left: 2px;\n    margin-right: 0px;\n}\n\n.latencyPlotContainer {\n    display: flex;\n    align-items: end;\n    \n    --p50: 0;\n    --p99: 0;\n    /* TODO: Determine total width of this thing with css variables */\n    --total-dur: 2000;\n    --total-width: 350px;\n\n    --p50-width: clamp(25px, calc(var(--p50) * var(--total-width) / var(--total-dur)), var(--total-width));\n    --p90-width: clamp(25px, calc((var(--p99) * var(--total-width) / var(--total-dur)) - var(--p50-width)), var(--total-width));\n}\n\n.latencyPlotBox {\n    margin-left: 0px;\n    margin-right: 0px;\n    border-radius: 0px;\n    border-top-right-radius: 2px;\n    text-indent: 2px;\n    text-wrap: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.p50PlotBox {\n    composes: latencyPlotBox;\n    background-color: #b17bdc;\n    height: 25px;\n    font-size: 10px;\n    font-weight: 600;\n    color: white;\n    width: var(--p50-width);\n}\n\n.p99PlotBox {\n    composes: latencyPlotBox;\n    background-color: #7544e5;\n    height: 22px;\n    font-size: 10px;\n    font-weight: 600;\n    color: white;\n    width: var(--p90-width);\n}\n\n.finalPlotBox {\n    composes: latencyPlotBox;\n    background-color: #d9d9d9;\n    height: 20px;\n    font-size: 12px;\n    justify-content: end;\n    padding-inline-end: 5px;\n    width: calc(var(--total-width) - var(--p50-width) - var(--p90-width));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"latencyContainer": `latencyDisplay_latencyContainer__tOFYF`,
	"statContainer": `latencyDisplay_statContainer__Ld16P`,
	"statTitle": `latencyDisplay_statTitle__0yM0V`,
	"statValue": `latencyDisplay_statValue__HieRF`,
	"statUnit": `latencyDisplay_statUnit__UHF+e`,
	"latencyPlotContainer": `latencyDisplay_latencyPlotContainer__+Kkjo`,
	"latencyPlotBox": `latencyDisplay_latencyPlotBox__eLYKR`,
	"p50PlotBox": `latencyDisplay_p50PlotBox__svRGg latencyDisplay_latencyPlotBox__eLYKR`,
	"p99PlotBox": `latencyDisplay_p99PlotBox__D396n latencyDisplay_latencyPlotBox__eLYKR`,
	"finalPlotBox": `latencyDisplay_finalPlotBox__BxgBu latencyDisplay_latencyPlotBox__eLYKR`
};
export default ___CSS_LOADER_EXPORT___;
